import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SplashPage } from './src/components/SplashPage';
import { ConnectPage } from './src/components/ConnectPage';
import QRConnectPage from './src/pages/QRConnectPage';
import { AdminLogin } from './src/secure/x9s4k-portal-72/admin/AdminLogin';
import { AdminDashboard } from './src/secure/x9s4k-portal-72/admin/AdminDashboard';
import { AdminRouteGuard } from './src/secure/x9s4k-portal-72/admin/AdminRouteGuard';
import { UserManagement } from './src/secure/x9s4k-portal-72/admin/UserManagement';
import { MembershipManagement } from './src/secure/x9s4k-portal-72/admin/MembershipManagement';
import { AnalyticsDashboard } from './src/secure/x9s4k-portal-72/admin/AnalyticsDashboard';
import { initPixels } from './src/tracking/pixels';
import PrivacyPolicy from './src/components/PrivacyPolicy';
import TermsOfUse from './src/components/TermsOfUse';
import SupportPage from './src/pages/SupportPage';
import { RawsterLayout } from './src/rawster/RawsterLayout';
import { RawsterLandingPage } from './src/rawster/RawsterLandingPage';
import { RawsterPrivacyPolicy } from './src/rawster/RawsterPrivacyPolicy';
import { RawsterTerms } from './src/rawster/RawsterTerms';
import { RawsterSupport } from './src/rawster/RawsterSupport';
import { AzaleaLayout } from './src/azalea/AzaleaLayout';
import { AzaleaLandingPage } from './src/azalea/AzaleaLandingPage';
import {
  AzaleaPrivacy,
  AzaleaTerms,
  AzaleaFaq,
  AzaleaSupport,
  AzaleaDataRights,
} from './src/azalea/AzaleaPages';

// Initialize pixel tracking
initPixels();

// Get root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Create React root and render with routing
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/connect" element={<ConnectPage />} />
        <Route path="/qr-connect" element={<QRConnectPage />} />
        {/* Admin Panel Routes - Hidden and Token Protected */}
        {/* More specific routes must come first */}
        <Route path="/x9s4k-portal-72/admin/login" element={<AdminLogin />} />
        <Route 
          path="/x9s4k-portal-72/admin/users" 
          element={
            <AdminRouteGuard>
              <UserManagement />
            </AdminRouteGuard>
          } 
        />
        <Route 
          path="/x9s4k-portal-72/admin/memberships" 
          element={
            <AdminRouteGuard>
              <MembershipManagement />
            </AdminRouteGuard>
          } 
        />
        <Route 
          path="/x9s4k-portal-72/admin/analytics" 
          element={
            <AdminRouteGuard>
              <AnalyticsDashboard />
            </AdminRouteGuard>
          } 
        />
        <Route 
          path="/x9s4k-portal-72/admin" 
          element={
            <AdminRouteGuard>
              <AdminDashboard />
            </AdminRouteGuard>
          } 
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/support" element={<SupportPage />} />
        {/* Azalea — picture communication app (no Gig Genie branding) */}
        <Route path="/azalea" element={<AzaleaLayout />}>
          <Route index element={<AzaleaLandingPage />} />
          <Route path="privacy" element={<AzaleaPrivacy />} />
          <Route path="terms" element={<AzaleaTerms />} />
          <Route path="faq" element={<AzaleaFaq />} />
          <Route path="support" element={<AzaleaSupport />} />
          <Route path="data-rights" element={<AzaleaDataRights />} />
        </Route>
        {/* AzaleaSpeak public web landing (copy of /azalea homepage for azalea-speak hosting) */}
        <Route path="/landing" element={<AzaleaLayout />}>
          <Route index element={<AzaleaLandingPage />} />
        </Route>
        {/* Rawster — standalone product (no Gig Genie branding) */}
        <Route path="/rawster" element={<RawsterLayout />}>
          <Route index element={<RawsterLandingPage />} />
          <Route path="privacy-policy" element={<RawsterPrivacyPolicy />} />
          <Route path="terms" element={<RawsterTerms />} />
          <Route path="support" element={<RawsterSupport />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

